import React from 'react';
export default () => (React.createElement("div", { className: "passkey-icons" },
    React.createElement("div", { className: "passkey-icon-wrapper", style: {
            left: 5,
        } },
        React.createElement("div", { style: {
                background: '#003087',
                maskImage: 'url("https://www.paypalobjects.com/paypal-ui/icons/v5/svg/fingerprint.svg")',
                width: 40,
                height: 40,
            } })),
    React.createElement("div", { className: "passkey-icon-wrapper", style: {
            left: 60,
        } },
        React.createElement("div", { style: {
                background: '#003087',
                maskImage: 'url("https://www.paypalobjects.com/paypal-ui/icons/v5/svg/passkey.svg")',
                width: 40,
                height: 40,
            } })),
    React.createElement("div", { className: "passkey-icon-wrapper", style: {
            right: 5,
        } },
        React.createElement("div", { style: {
                background: '#003087',
                maskImage: 'url("https://www.paypalobjects.com/paypal-ui/icons/v5/svg/face-id.svg")',
                width: 40,
                height: 40,
            } }))));
